import React from 'react';
import {
  IconDataflow,
  IconTerminal,
  IconShieldTick,
  IconBankNote,
  IconAdd,
  IconAiPencil,
  IconStarMoving,
  IconDashboard,
  IconMail,
  IconMenu,
  IconSites,
  IconSupport,
  IconTools,
  IconN8N,
  IconAiReload,
  IconPhoto,
  IconTool,
  IconAiCleaning,
  IconRobot,
  IconClock,
  IconChatCheck,
  IconMegaphone,
  IconBag,
  IconOpenClaw,
} from 'gatorcomponents';
import VpsN8nImage from '@/pages/Home/media/vps-n8n.png';
import VpsOpenClawImage from '@/pages/Home/media/vps-open-claw.png';
import WordPressAIImage from '@/pages/Home/media/wordpress-ai.png';
import HGStudioImage from '@/pages/Home/media/hg-studio.png';
import SiteBuilderV2Image from '@/pages/Home/media/site-builder-v2.png';
import EmailTitanImage from '@/pages/Home/media/email-titan.png';
import AiAgentsImage from '@/pages/Home/media/ai-agents.png';
import IconAiPenMenu from '@/pages/Home/media/iconAiPenMenu';
import { PRODUCTS_HIGHLIGHT_IDS } from '../../pages/Home/HomeHandler.enum';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import { SITE_HG } from '@/config';

const n8nPrice = 25.89;

export default {
  aiConversationBanner: {
    betaTag: 'Beta',
    title: (name = '') => `Olá, ${name}. O que você quer que eu faça hoje?`,
    input: {
      placeholderAlreadyOpened: 'Você já tem um chat aberto com o Gator',
      placeholder: 'Pergunte ou peça ao Gator para fazer alguma coisa...',
    },
    audio: {
      recordingLabel: 'Ouvindo...',
      transcribingLabel: 'Gerando Transcrição...',
    },
    suggestions: [
      {
        Icon: IconDashboard,
        id: 'create-site',
        label: 'Criar site',
        initialMessage: 'Me ajude a criar um novo site',
        action: 'newSite',
        value: OPTIONS.CREATE_SITE,
      },
      {
        Icon: IconMail,
        id: 'create-email',
        label: 'Criar e-mail',
        initialMessage: 'Me ajude a criar um e-mail profissional',
        action: 'email',
        value: OPTIONS.CREATE_EMAIL,
      },
      {
        Icon: IconStarMoving,
        id: 'marketing-tips',
        label: 'Marketing',
        initialMessage: 'Liste as formas em que você pode me ajudar com marketing',
        value: OPTIONS.MARKETING_TIPS,
        websocketType: 'multi-agent',
      },
      {
        Icon: IconSupport,
        id: 'support',
        label: 'Suporte',
        value: OPTIONS.SUPPORT,
        initialMessage: 'Preciso de suporte',
      },
      {
        Icon: IconMenu,
        id: 'more',
        label: 'Mais',
        action: 'expand',
        value: OPTIONS.MORE,
      },
      {
        Icon: IconAdd,
        hideOnInit: true,
        id: 'contract-domain',
        label: 'Contratar domínio',
        initialMessage: 'Quero contratar um domínio',
        value: OPTIONS.DOMAIN_PURCHASE,
      },
      {
        Icon: IconSites,
        hideOnInit: true,
        id: 'configure-domain',
        label: 'Configurar domínio (DNS)',
        initialMessage: 'Configure o meu domínio',
        action: 'domainConfig',
        value: OPTIONS.CONFIGURE_DOMAIN,
      },
      {
        Icon: IconTools,
        hideOnInit: true,
        id: 'check-account',
        label: 'Checar minha conta',
        initialMessage: 'Faça um diagnóstico da minha conta',
        value: OPTIONS.CHECK_ACCOUNT,
      },
      {
        Icon: IconAiPencil,
        hideOnInit: true,
        id: 'create-posts',
        label: 'Criar posts',
        initialMessage: 'Me ajude a criar mensagens para posts nas redes sociais',
        value: OPTIONS.CREATE_POSTS,
      },
      {
        Icon: IconBag,
        hideOnInit: true,
        id: 'contract-product',
        label: 'Contratar produto',
        initialMessage: 'Quero contratar um novo produto',
      },
    ],
  },
  greetingBanner: {
    title: (name = '') => (
      <>
        Olá,
        {' '}
        <strong>{name}</strong>
        !
      </>
    ),
    subtitle: 'Que bom ter você por aqui!',
    cta: {
      label: 'Criar site',
      link: '/sites/criar-site',
    },
  },
  bannerAiAgent: {
    popover: {
      title: 'Sou uma Inteligência Artificial',
      description: 'Eu faço seu site ficar pronto rapidinho! Quer ver como é fácil?',
      buttonLabel: 'Entendi',
    },
  },
  VinculedGoogle: {
    title: 'Sucesso na vinculação de conta com o Google!',
    message: 'Agora você poderá logar com seu usuário e senha ou diretamente pelo Google',
  },
  ContractedProducts: {
    hosting: {
      title: 'Hospedagens',
      buttonGoToLabel: 'Ir para Hospedagem',
      empty: {
        title: 'Hospede o seu site com qualidade e conquiste o mundo digital!',
        subtitle: 'Escolha uma hospedagem confiável e leve o seu negócio para o próximo nível.',
        buttonLabel: 'Contratar hospedagem',
      },
    },
    domain: {
      title: 'Domínios',
      buttonGoToLabel: 'Ir para Domínio',
      empty: {
        title: 'Garanta o seu domínio agora e destaque-se online!',
        subtitle: 'Cadastre já o seu domínio e leve o seu negócio para o próximo nível.',
        buttonLabel: 'Contratar domínio',
      },
    },
    buttonLabelManage: 'Gerenciar',
    expiresOn: 'Expira em',
    hostingStatus: {
      pending: 'Pendente',
      active: 'Ativo',
      completed: 'Completo',
      suspended: 'Suspenso',
      terminated: 'Encerrado',
      cancelled: 'Cancelado',
      fraud: 'Fraude',
      building: 'Em Configuração',
      activationPending: 'Aguardando ativação',
    },
  },
  infosMenuHighlight: {
    tagNew: 'Novo',
    studioGuide: {
      title: 'Conheça o HostGator Studio',
      description: 'Aproveite a funcionalidade do Studio para criar conteúdos grátis para o seu negócio.',
    },
    staticHighlights: [
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_BUILDER,
        size: 100,
        name: 'HostGator Builder',
        title: 'Criador de Sites',
        subtitle: 'Chegou o Novo Criador de Sites com IA',
        description: 'Sem códigos. Sem complicação. Só resultados. Você fala, a IA faz. Sua empresa online? Só aqui!',
        link: '/sites/criar-site',
        image: SiteBuilderV2Image,
        cta: 'Criar meu site',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crie seu site',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
        size: 100,
        name: 'HighLightProduct',
        title: 'WordPress',
        subtitle: 'Tenha um site pronto para vender mais!',
        description: 'Nosso WordPress com IA faz tudo pra você: textos, imagens, design, sem complicações! Você só precisa alterar se quiser.',
        link: '/sites/criar-site',
        image: WordPressAIImage,
        cta: 'Criar meu site',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crie seu site',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
        size: 100,
        name: 'HighLightProduct',
        title: 'E-mail Titan',
        subtitle: 'Tenha um e-mail com o nome da sua marca!',
        description: 'Ganhe a confiança dos seus clientes. Crie contas para cada equipe e marque reuniões com calendário.',
        tag_color: '#FFCF00',
        link: 'open_merlin',
        image: EmailTitanImage,
        cta: 'Criar e-mail',
        link_open_behavior: 'function',
        menu: {
          title: 'E-mail Profissional',
          icon: <IconMail color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_FREE,
        titleTag: 'Grátis',
        size: 100,
        name: 'HostGator Studio',
        title: 'HostGator Studio',
        subtitle: 'Transforme suas ideias em designs incríveis',
        descriptionList: [
          {
            icon: <IconAiReload color="lowPure" />,
            text: 'Crie logo com Inteligência Artificial',
            id: 'reload',
          },
          {
            icon: <IconPhoto color="lowPure" />,
            text: 'Templates gratuítos em vários formatos ',
            id: 'templates',
          },
          {
            icon: <IconTool color="lowPure" />,
            text: 'Dimensões personalizadas',
            id: 'dimensions',
          },
        ],
        link: '/studio',
        image: HGStudioImage,
        cta: 'Acessar Studio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'HostGator Studio',
          icon: <IconAiPenMenu />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO,
        size: 100,
        name: 'HostGator Studio',
        title: 'HostGator Studio Pro',
        subtitle: 'Transforme suas ideias em designs incríveis',
        descriptionList: [
          {
            icon: <IconAiReload color="lowPure" />,
            text: 'Crie logo com Inteligência Artificial',
            id: 'reload',
          },
          {
            icon: <IconPhoto color="lowPure" />,
            text: 'Templates gratuítos em vários formatos ',
            id: 'templates',
          },
          {
            icon: <IconAiCleaning color="lowPure" />,
            text: 'Removedor de fundo',
            id: 'background_remover',
          },
        ],
        link: '/studio',
        image: HGStudioImage,
        cta: 'Acessar Studio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'HostGator Studio',
          icon: <IconAiPenMenu />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL,
        titleTag: 'Grátis',
        free: true,
        size: 100,
        name: 'HostGator Studio',
        title: 'HostGator Studio',
        subtitle: 'Transforme suas ideias em designs incríveis',
        descriptionList: [
          {
            icon: <IconAiReload color="lowPure" />,
            text: 'Crie logo com Inteligência Artificial',
            id: 'reload',
          },
          {
            icon: <IconPhoto color="lowPure" />,
            text: 'Templates gratuítos em vários formatos ',
            id: 'templates',
          },
          {
            icon: <IconTool color="lowPure" />,
            text: 'Dimensões personalizadas',
            id: 'dimensions',
          },
        ],
        link: '/studio',
        image: HGStudioImage,
        cta: 'Acessar Studio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'HostGator Studio',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.AI_AGENTS,
        size: 100,
        name: 'Agentes de IA',
        subtitle: 'Só no Criador de Sites: aproveite agora!',
        title: 'Tenha um Agente de IA que atende para você',
        badge: 'Grátis no seu plano',
        image: AiAgentsImage,
        cta: 'Quero meu agente',
        descriptionList: [
          {
            icon: <IconChatCheck color="lowPure" />,
            text: 'Responder dúvidas em segundos.',
            id: 'reply',
          },
          {
            icon: <IconMegaphone color="lowPure" />,
            text: 'Apresentar seus produtos e serviços.',
            id: 'show_products',
          },
          {
            icon: <IconClock color="lowPure" />,
            text: 'Atendimento 24 horas por dia',
            id: '24_hours_support',
          },
        ],
        menu: {
          title: 'Crie seu Agente de IA',
          icon: <IconRobot color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_N8N,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS n8n',
        description: 'Crie e rode suas automações em minutos',
        descriptionPrefix: (price = n8nPrice) => `a partir de ${formatCurrency(price)}/mês`,
        descriptionList: [
          {
            icon: <IconDataflow color="lowPure" />,
            text: 'Fluxos de trabalho e integrações ilimitadas',
            id: 'dataflow',
          },
          {
            icon: <IconTerminal color="lowPure" />,
            text: 'Acesso root e liberdade para customizar',
            id: 'terminal',
          },
          {
            icon: <IconShieldTick color="lowPure" />,
            text: 'Ambiente isolado e confiável',
            id: 'shield',
          },
          {
            icon: <IconBankNote color="lowPure" />,
            text: 'Sem cobranças por tarefas ou limites de uso',
            id: 'banknote',
          },
        ],
        link: '/sites/criar-site',
        image: VpsN8nImage,
        cta: 'Conhecer VPS n8n',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Servidor VPS n8n',
          icon: <IconN8N color="primaryExtraDark" />,
        },
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_OPEN_CLAW,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS OpenClaw',
        subtitle: (
          <>
            Coloque um
            {' '}
            <span>agente de IA</span>
            {' '}
            para agir por você
          </>
        ),
        description: 'Automatize tarefas, integre plataformas e reduza o trabalho manual. O OpenClaw executa processos de forma autônoma e trabalha continuamente para você no seu dia a dia.',
        link: `${SITE_HG}/servidor-vps/openclaw`,
        image: VpsOpenClawImage,
        cta: 'Conhecer VPS OpenClaw',
        link_open_behavior: 'new_tab',
        menu: {
          title: 'Servidor VPS OpenClaw',
          icon: <IconOpenClaw color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
    ],
  },
  infosLoadingError: {
    buttonLabel: 'Recarregar Página',
    message: (
      <>
        Ocorreu um erro ao carregar a página
        {' '}
        <br />
        Caso persista, tente novamente mais tarde.
      </>
    ),
  },
};
